import React from 'react';
const DEMO_URL = 'https://demo.lentic.ai';

/**
 * Fallback for client-side navigation to /demo. The primary mechanism is the
 * side-effect check in utils/demoRedirect, which runs before the app mounts.
 * Renders nothing, and fires during render so no layout paints.
 */
export function DemoRedirect() {
  if (typeof window !== 'undefined') {
    window.location.replace(DEMO_URL);
  }
  return null;
}